import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/SyriaMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة معدل الفرز للسنة التحضيرية في سوريا";
const DESCRIPTION =
  "احسب معدل الفرز للقبول في الكليات الطبية السورية بدقة - أدخل درجات السنة التحضيرية والبكالوريا (علمي) لمعرفة فرصك في الطب البشري، الصيدلة، أو طب الأسنان!";
const KEYWORDS = "حاسبة, معدل الفرز, سنة تحضيرية, بكالوريا, قبول, سوريا";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SY/calculators-list/preparatory-year-calculator/";
function PreparatoryYearCalculator() {
  const [firstTermGrades, setFirstTermGrades] = useState(Array(5).fill());
  const [secondTermGrades, setSecondTermGrades] = useState(Array(5).fill());
  const [baccalaureateGrade, setBaccalaureateGrade] = useState("");
  const [finalScore, setFinalScore] = useState(null);
  const [error, setError] = useState("");
  const calculateFinalScore = () => {
    try {
      const firstTermAverage =
        firstTermGrades.reduce((acc, curr) => acc + Number(curr), 0) / 5;
      const firstTermScore = (firstTermAverage * 30) / 100;
      const secondTermAverage =
        secondTermGrades.reduce((acc, curr) => acc + Number(curr), 0) / 5;
      const secondTermScore = (secondTermAverage * 30) / 100;
      const preparatoryScore = firstTermScore + secondTermScore;
      const baccalaureateScore = (baccalaureateGrade * 40) / 240;
      const finalScore = preparatoryScore + baccalaureateScore;
      setFinalScore(finalScore.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تتطلع لدراسة الطب في سوريا؟ هل تتساءل عن فرص قبولك في
                  الكليات الطبية؟ حاسبتنا الذكية هي الأداة المثالية لتقدير معدل
                  الفرز الخاص بك بدقة. ببساطة، أدخل درجاتك في السنة التحضيرية
                  ودرجات البكالوريا، وستحصل على تقدير لمعدل الفرز الذي قد يحققه
                  طلبك.
                </p>
                <p>
                  تقوم حاسبتنا بحساب معدل الفرز وفقاً للمعايير التي تعتمدها
                  وزارة التعليم العالي في سوريا، مما يمنحك تقديراً دقيقاً لموقعك
                  التنافسي. استخدم هذه المعلومات لتخطيط خطواتك القادمة وتحديد
                  الكليات الطبية التي يمكنك التقدم إليها.
                </p>
                <p>
                  معدل الفرز هو مؤشر رقمي يحدد ترتيب الطلاب المتقدمين للكليات
                  الطبية في سوريا. يتم حسابه بناءً على مجموع درجاتك في السنة
                  التحضيرية ودرجات البكالوريا. كلما كان معدل الفرز الخاص بك
                  أعلى، زادت فرص قبولك في الكليات الطبية المرموقة.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u>
                    <b>ملاحظة هامة</b>:
                  </u>{" "}
                  <b >
                    تاريخ آخر تحديث: {" "}
                    <time dateTime="2026-01-10">28/02/2026</time>
                  </b>
                </div>
                <div className="p-3">
                                    <div className="form-group">
                    <label>درجات الفصل الأول (5 مواد):</label>
                    {firstTermGrades.map((grade, index) => (
                      <input
                        key={index}
                        type="number"
                        value={grade}
                        onChange={(e) =>
                          setFirstTermGrades((prev) => {
                            const updatedGrades = [...prev];
                            updatedGrades[index] = e.target.value;
                            return updatedGrades;
                          })
                        }
                        className="form-control mb-2"
                        placeholder={`المادة ${index + 1}`}
                      />
                    ))}
                  </div>
                                    <div className="form-group">
                    <label>درجات الفصل الثاني (5 مواد):</label>
                    {secondTermGrades.map((grade, index) => (
                      <input
                        key={index}
                        type="number"
                        value={grade}
                        onChange={(e) =>
                          setSecondTermGrades((prev) => {
                            const updatedGrades = [...prev];
                            updatedGrades[index] = e.target.value;
                            return updatedGrades;
                          })
                        }
                        className="form-control mb-2"
                        placeholder={`المادة ${index + 1}`}
                      />
                    ))}
                  </div>
                                    <div className="form-group">
                    <label htmlFor="bac">درجة البكالوريا (من 240):</label>
                    <input
                      id="bac"
                      type="number"
                      value={baccalaureateGrade}
                      onChange={(e) => setBaccalaureateGrade(e.target.value)}
                      className="form-control mb-2"
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateFinalScore}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  finalScore !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>معدل الفرز: {finalScore} من 100</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب معدل الفرز</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: حساب معدل الفصل الأول
                    </h2>
                  </u>
                  <p>
                    مجموع درجات الفصل الأول من 5 مواد مقسومًا على 5، ثم ضرب
                    النتيجة بـ 30% للحصول على النسبة الداخلة في معدل الفرز من
                    الفصل الأول.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: حساب معدل الفصل الثاني
                    </h2>
                  </u>
                  <p>
                    مجموع درجات الفصل الثاني من 5 مواد مقسومًا على 5، ثم ضرب
                    النتيجة بـ 30% للحصول على النسبة الداخلة في معدل الفرز من
                    الفصل الثاني.
                  </p>
                  <br />
                </div>
                p
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب معدل السنة التحضيرية
                    </h2>
                  </u>
                  <p>
                    جمع نسبة الفرز من الفصل الأول ونسبة الفرز من الفصل الثاني
                    للحصول على نسبة 60% من السنة التحضيرية.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان معدل الفصل الأول 80 ومعدل الفصل الثاني 85، فإن
                    نسبة الفرز للسنة التحضيرية = 60% × ((80 + 85) ÷ 2).
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: حساب معدل البكالوريا
                    </h2>
                  </u>
                  <p>
                    حساب نسبة الفرز من البكالوريا عن طريق تقسيم درجة البكالوريا
                    على 240 وضرب النتيجة بـ 40%.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 5: حساب المعدل النهائي
                    </h2>
                  </u>
                  <p>
                    جمع نسبة السنة التحضيرية ونسبة البكالوريا للحصول على المعدل
                    النهائي للفرز.
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PreparatoryYearCalculator;
